import {authHeader} from '../_helpers';
import {handleResponse} from '../_helpers';


export const countryService = {
    getCountryCollection
};


function getCountryCollection() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(process.env.VUE_APP_API_SERVER+`/api/countries`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}